// src/components/dialog/DlgPayloadIssues.tsx

import { BugReportTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Chip,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

import { DlgCloseButton, HStack } from '..'
import { getRelativeDate } from '../../api'

const isValidJson = payload => {
  let result = false

  try {
    JSON.parse(
      payload
        .replaceAll("'", '"')
        .replaceAll('None', '"undefined"')
        .replaceAll('True', '"True"')
        .replaceAll('False', '"False"')
    )
    result = true
  } catch {
    result = false
  }

  return result
}

type Props = KARMA_BasicDialog & {
  data: any[]
  issues: number
}

export const DlgPayloadIssues = ({ data, open, onClose, issues }: Props) => {
  const theme = useTheme()
  const { main: bgcolor } = theme.palette.secondary
  const { white } = theme.palette
  const color = issues === 0 ? 'success' : 'error'

  return (
    <Dialog maxWidth={'xl'} onClose={onClose} open={open}>
      <DialogTitle>
        <HStack>
          <Avatar sx={{ bgcolor, color: white, mr: 1 }}>
            <BugReportTwoTone />
          </Avatar>

          <Typography sx={{ mr: 1 }}>
            Ungültige Payloads{' '}
            <Chip color={color} label={issues} sx={{ ml: 1 }} />
          </Typography>
        </HStack>

        <DlgCloseButton onClick={onClose} />
      </DialogTitle>

      <DialogContent>
        <List>
          {data
            ?.filter(item => !isValidJson(item.payload))
            .map(item => {
              const primary = item.device_id
              const secondary = `${item.timestamp} | ${getRelativeDate(
                item.timestamp
              )}`

              return (
                <ListItem key={primary}>
                  <Stack>
                    <ListItemButton>
                      <ListItemText primary={primary} secondary={secondary} />
                    </ListItemButton>

                    <Collapse in={true}>
                      <Typography>
                        <code>{item.payload}</code>
                      </Typography>
                    </Collapse>
                  </Stack>
                </ListItem>
              )
            })}
        </List>
      </DialogContent>
    </Dialog>
  )
}
